import React from 'react';
import { useSelector } from 'react-redux';
import { GlobalStyles, createTheme, ThemeProvider, alpha } from '@mui/material';
import getOverrides from './UIComponents/muiOverrides.js';
import BrowserSupportModal from './BrowserSupportModal.js';
import Routes from '../routes.js';

const App = () => {
    const theme = useSelector((state) => state.site.theme);
    const muiTheme = createTheme({
        palette: {
            primary: {
                main: theme.colors.primary,
            },
            secondary: {
                main: theme.colors.secondary,
            },
            backgroundColor: {
                default: theme.colors.mainBackground,
            },
        },
        spacing: theme.spacing,
        components: getOverrides(theme),
    });

    return (
        <ThemeProvider theme={ muiTheme }>
            <GlobalStyles
                styles={{
                    '.Mui-selected .MuiTypography-root': {
                        fontWeight: 500,
                    },
                    '.MuiTableRow-root.MuiTableRow-hover:hover': {
                        backgroundColor: `${alpha(muiTheme.palette.primary.main, 0.15)} !important`,
                        cursor: 'pointer',
                    },
                    '.MuiTableRow-root.Mui-selected': {
                        backgroundColor: `${alpha(muiTheme.palette.primary.main, 0.3)} !important`,
                    },
                    '.chrome-picker': {
                        boxShadow: 'none !important',
                    },
                    '.chrome-picker > *': {
                        borderRadius: '0px !important',
                    },
                    '.MuiTooltip-tooltip': {
                        backgroundColor: `${muiTheme.palette.common.black} !important`,
                        fontSize: '0.85rem !important',
                    },
                    '.MuiTooltip-arrow': {
                        color: `${muiTheme.palette.common.black} !important`,
                    },
                }}
            />
            <BrowserSupportModal />
            <Routes />
        </ThemeProvider>
    );
};

export default App;
